import React, { ReactNode } from 'react';
import { Info } from 'lucide-react';
import { TooltipContentProps } from '@radix-ui/react-tooltip';
import { Button, ButtonProps } from '@/Components/shadcn/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/Components/shadcn';
import { cn } from '@/lib/utils';

interface InfoTooltipProps extends Pick<TooltipContentProps, 'side'>, Pick<ButtonProps, 'size'> {
    title?: string;
    description: string | ReactNode;
    className?: string;
}

const InfoTooltip = ({ description, title, className, side = 'bottom', size = 'icon-xs' }: InfoTooltipProps) => {
    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <Button
                        type="button"
                        variant="ghost"
                        size={size}
                        className={cn('text-muted-foreground size-6 shrink-0', className)}
                        aria-label={title ?? 'Information'}
                    >
                        <Info className="size-4" />
                    </Button>
                </TooltipTrigger>
                <TooltipContent
                    side={side}
                    className={cn('border-border bg-popover max-w-sm border px-4 py-3 text-sm shadow-md')}
                    arrowProps={{ className: 'border-b border-r border-border bg-popover fill-popover' }}
                >
                    {typeof description === 'string' ? (
                        <div className="flex flex-col items-start gap-2">
                            {title ? (
                                <p className="text-foreground text-base leading-snug font-semibold">{title}</p>
                            ) : null}
                            <p className="text-foreground leading-relaxed">{description}</p>
                        </div>
                    ) : (
                        description
                    )}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};

export default InfoTooltip;
